// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"Rx-z","giftOrPromoSelector":"Sx-z","disabled":"Tx-z","subTitle":"Ux-z","selectShipAddressMessage":"Vx-z","changePayment":"Wx-z"};